import { render, staticRenderFns } from "./storage_stay_duration_list.vue?vue&type=template&id=67fb1ad9"
import script from "./storage_stay_duration_list.vue?vue&type=script&lang=js"
export * from "./storage_stay_duration_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports